import "./styles/custom.css";
import "./styles/form.scss";
import "./styles/common.scss";

import React from "react";
import HRDContainer from "./layout/hrdContainer";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ConfigLoader from "./context/ConfigContext";

function App() {
  return (
    <ConfigLoader>
      <Router>
        <Routes>
          <Route path="/authorize" element={<HRDContainer />} />
        </Routes>
      </Router>
    </ConfigLoader>
  );
}

export default App;